import GraphLoadSave from './5-load-save';

export default GraphLoadSave;
